
    <form [formGroup]="formData">
      <div style="margin-top: 50px"
           formArrayName="layoutList"
           *ngFor="let item of controls(); let i=index">
        <div [formGroupName]="i.toString()">
          <button
            pButton
            type="button"
            class="k-generic-btn"
            icon="fa fa-minus-circle"
            iconPos="left"
            label="{{ 'common.delete' | translate }}"
            (click)="deletePrivacyList(i)">
          </button>
          <div class="ui-g ui-fluid master-data customer-cards-info">
            <p-panel class="ui-g-12 ui-md-12">
              <p-header>
                <div style="height: 20px">
                  <div style="text-align: center; font-size: medium; font-weight: bold">{{ 'promotion.messageLayout' | translate }}</div>
                </div>
              </p-header>
              <div class="ui-g-12 ui-fluid">
                <div [kv-form-element]="{ label: 'promotion.touchPoint', md: '6' }">
                  <p-dropdown
                    [options]="touchPoints"
                    formControlName="ochannel_id">
                  </p-dropdown>
                </div>
                <div [kv-form-element]="{ label: 'layout.layout', md: '6' }">
                  <p-dropdown
                    [options]="layouts"
                    formControlName="message_layout_id">
                  </p-dropdown>
                </div>
                <div [kv-form-element]="{ label: '', md: '2'}"></div>
                <div [kv-form-element]="{ label: 'promotion.startVisibility', md: '3'}">
                  <p-calendar
                    class="over"
                    [showIcon]="true"
                    formControlName="start_visibility_date"
                    [readonlyInput]="false"
                    [dateFormat]="calendarTranslate.dateFormat">
                  </p-calendar>
                </div>
                <div [kv-form-element]="{ label: '', md: '2'}"></div>
                <div [kv-form-element]="{ label: 'promotion.endVisibility', md: '3'}">
                  <p-calendar
                    class="over"
                    [showIcon]="true"
                    formControlName="end_visibility_date"
                    [readonlyInput]="false"
                    [dateFormat]="calendarTranslate.dateFormat">
                  </p-calendar>
                </div>
                <div [kv-form-element]="{ label: '', md: '2'}"></div>
              </div>
            </p-panel>
            <div class="ui-g-12 text-right">
              <button
                pButton
                type="submit"
                class="k-generic-btn"
                icon="fa fa-floppy-o"
                iconPos="left"
                label="{{ 'common.save' | translate }}"
                (click)="save(i)">
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
    <button
      pButton
      type="button"
      class="k-generic-btn"
      icon="fa fa-plus-circle"
      label="{{'common.add' | translate}}"
      (click)="addPrivacy()">
    </button>
  


// WEBPACK FOOTER //
// ./src/app/views/promotion/message/components/tab/layout/tabLayout.component.ts.TabLayoutComponent.html